import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { event } from '../../services/analyticsService';
import { useAuth } from '../../authentication/AuthContext';
import '../../styles/AccountPage.css';
import '../usecases/usecases.css';

function UseCasesIndexPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const trackUseCaseClick = (useCaseType) => {
    event({
      action: 'use_case_click',
      category: 'navigation',
      label: useCaseType
    });
  };

  const trackGeneralResearchClick = () => {
    event({
      action: 'general_research_click',
      category: 'navigation',
      label: 'from_use_cases_page'
    });

    if (!user) {
      navigate('/login', {
        state: {
          from: '/research',
          message: 'Please log in to access the app and start your research'
        }
      });
      return;
    }

    navigate('/research');
  };

  // Use case data
  const useCases = [
    {
      title: "Startup & Product Validation",
      description: "Test product ideas before building to ensure market fit and identify improvement opportunities",
      icon: "/InstantFlowsicon_wb.png",
      linkPath: "/use-cases/startup-validation",
      examplePath: "/exampleresearches",
      exampleState: { filter: "startup-validation" },
      trackingId: "startup_validation"
    },
    {
      title: "Branding Feedback",
      description: "Understand how your brand identity resonates with different audience segments",
      icon: "/InstantFlowsicon_wb.png",
      linkPath: "/use-cases/branding-feedback",
      examplePath: "/exampleresearches",
      exampleState: { filter: "branding-feedback" },
      trackingId: "branding_feedback"
    },
    {
      title: "Campaign Validation",
      description: "Test marketing campaigns before launch to ensure message clarity and effectiveness",
      icon: "/InstantFlowsicon_wb.png",
      linkPath: "/use-cases/campaign-validation",
      examplePath: "/exampleresearches",
      exampleState: { filter: "campaign-validation" },
      trackingId: "campaign_validation"
    }
  ];

  return (
    <div className="account-page">
      <div className="account-container">
        <div className="usecase-header">
          <h1 className="account-title">How can we help you?</h1>
          <p className="usecase-subtitle">Explore our specialized research templates for different business needs</p>
        </div>
        
        <div className="usecases-card">
          <h2 className="usecase-section-title">Our Research Templates</h2>
          
          <div className="usecase-cards-container">
            {useCases.map((useCase, index) => (
              <Link 
                key={index}
                to={useCase.linkPath}
                onClick={() => trackUseCaseClick(useCase.trackingId)}
                className={`usecase-card ${index === 1 ? 'usecase-card-highlight' : ''}`}
              >
                <div className="usecase-card-icon-container">
                  <img 
                    src={useCase.icon} 
                    alt={useCase.title} 
                    className="usecase-card-icon" 
                  />
                </div>
                
                <h3 className="usecase-card-title">{useCase.title}</h3>
                
                <p className="usecase-card-description">{useCase.description}</p>
                
                <div className="usecase-card-action">
                  <span className="usecase-learn-more">Learn More</span>
                </div>
              </Link>
            ))}
          </div>
          
          <p className="usecase-description">
            InstantFlows offers specialized research templates for different business needs. 
            Select the use case that fits your current challenge.
          </p>
        </div>
        
        <div className="usecase-general-cta">
          <h2 className="usecase-cta-title">Not sure which to choose?</h2>
          <p className="usecase-cta-description">
            Start with our general research template or contact us for guidance.
          </p>
          <button 
            className="usecase-cta-button"
            onClick={trackGeneralResearchClick}
          >
            Start General Research
          </button>
        </div>
      </div>
    </div>
  );
}

export default UseCasesIndexPage;